module.exports = __webpack_public_path__ + "static/media/sc_2_i.38ba5507.png";